import React, { useState, useEffect, useMemo, useCallback } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Grid, Paper, Typography, capitalize, IconButton } from "@mui/material";
import EditableTable from "../../../../Controllers/EditableTable";
import service from "./../../helpers/GifService";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLoading } from "../../../../providers/loadingProvider";
import { useNotify } from "../../../../providers/NotificationProvider";
import { canEditSelector } from "../../../../store/applicantsSlice";
import { useSelector } from "react-redux";
import { registerReferee } from "../../helpers/GifService/applicantService";
import { recommendedBy } from "../../Constants";
import InfoDialog from "../ProjectFinancing/InfoDialog";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  selectTableCell: {
    minWidth: 150,
  },
  textError: {
    color: "red",
  },
  editButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  infoIcon: {
    marginLeft: 5,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const ValidateEmail = (mail) => {
  if (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      mail
    )
  ) {
    return true;
  }
  return false;
};

const buildProposalContact = (proposalRefereeContact, proposalReferee) => {
  proposalRefereeContact["titleCode"] = proposalReferee.titleCode;
  proposalRefereeContact["title"] = proposalReferee.title;
  proposalRefereeContact["firstName"] = proposalReferee.firstName;
  proposalRefereeContact["lastName"] = proposalReferee.lastName;
  proposalRefereeContact["institution"] = proposalReferee.institutionId;
  proposalRefereeContact["institutionName"] = proposalReferee.institutionName;
  proposalRefereeContact["websiteurl"] = proposalReferee.websiteurl;
  proposalRefereeContact["primaryEmail"] = proposalReferee.primaryEmail;
  proposalRefereeContact["country"] = proposalReferee.institutionCountryName;
  proposalRefereeContact["countryCode"] = proposalReferee.institutionCountryId;
};

const infoContent = `GIF policy for recommending reviewers should follow the list below:
1. The reviewer is NOT from the same institute as one of the applicants.
2. The reviewer was NOT the PhD advisor/mentor of one of the applicants.
3. The reviewer was NOT one of the applicant’s Postdoc host.
4. The reviewer did NOT work and publish together with one of the applicants in the past 7 years.
* While GIF respects the applicants’ requests to exclude specified reviewers, we cannot guarantee that all reviewers suggested by the applicants will be approached.`;

export default function SuggestedReviewers() {
  const classes = useStyles();
  const loading = useLoading();
  const notify = useNotify();
  const [proposalId, setproposalId] = useState();
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [titlesOptions, setTitlesOptions] = useState([]);
  const [proposalReferees, setProposalReferees] = useState([]);
  const canEdit = useSelector(canEditSelector);
  const [showInfo, setShowInfo] = useState(false);

  const validateRow = (row) => {
    let errorList = [];
    if (
      row.titleCode === null ||
      row.titleCode === undefined ||
      row.titleCode === ""
    )
      errorList.push("Title");
    if (
      row.firstName === null ||
      row.firstName === undefined ||
      row.firstName === ""
    )
      errorList.push("First Name");
    if (
      row.lastName === null ||
      row.lastName === undefined ||
      row.lastName === ""
    )
      errorList.push("Last Name");
    if (
      row.institutionName === null ||
      row.institutionName === undefined ||
      row.institutionName === ""
    )
      errorList.push("Institution");
    if (
      row.websiteurl === null ||
      row.websiteurl === undefined ||
      row.websiteurl === ""
    )
      errorList.push("WebSite");
    if (
      row.primaryEmail === null ||
      row.primaryEmail === undefined ||
      row.primaryEmail === ""
    )
      errorList.push("Email");

    if (errorList.length === 0) {
      if (ValidateEmail(row.primaryEmail)) return true;
      else {
        notify.show(`You have entered an invalid email address!`, {
          severity: "error",
        });
        return false;
      }
    }

    notify.show(`Missing Fields:  ${errorList.join(", ")}`, {
      severity: "error",
    });

    return false;
  };

  const setRow = async (row) => {
    const loadingId = loading.addLoading("updating Reviewer");
    const capRow = {
      ...row,
      firstName: capitalize(row.firstName),
      lastName: capitalize(row.lastName),
    };
    var proposalRefereeContact = await service.GetContactByProposalRefereeId({
      ProposalRefereeId: capRow.id,
    });
    buildProposalContact(proposalRefereeContact, capRow);
    service
      .updateProposalRefreeByContact({
        proposalRefereeId: capRow.id,
        contact: proposalRefereeContact,
      })
      .then(() => {
        getProposalReferees(proposalId);
        loading.removeLoading(loadingId);
      });
  };

  const addRow = async (row) => {
    const loadingId = loading.addLoading("adding Reviewer");
    var proposalRefereeContact = {};
    const capRow = {
      ...row,
      firstName: capitalize(row.firstName),
      lastName: capitalize(row.lastName),
    };
    buildProposalContact(proposalRefereeContact, capRow);
    registerReferee({ email: capRow.primaryEmail });
    service
      .createProposalRefreeByContact({
        proposalId: proposalId,
        contact: proposalRefereeContact,
        recommendedBy: recommendedBy.ApplicantSuggestedReviewer,
      })
      .then(() => {
        getProposalReferees(proposalId);
        loading.removeLoading(loadingId);
      });
  };

  const deleteRow = (proposalRefereeId) => {
    const loadingId = loading.addLoading("removing Reviewer");
    service.DeactiveProposalRefferee({ proposalRefereeId }).then(() => {
      getProposalReferees(proposalId);
      loading.removeLoading(loadingId);
    });
  };

  const fillInstitutionsOptions = useCallback(async () => {
    const loadingId = loading.addLoading("loading institutions");
    var institutions = await service.getAllInstitutions(false);
    setInstitutionOptions(
      institutions.map((i) => ({ ...i, id: i.name, label: i.name }))
    );
    loading.removeLoading(loadingId);
  }, [loading]);

  const fillCountriesOptions = useCallback(async () => {
    const loadingId = loading.addLoading("loading countries");
    var countries = await service.getAllCountries();
    setCountriesOptions(
      countries.map((c) => ({ ...c, id: c.id, label: c.name }))
    );
    loading.removeLoading(loadingId);
  }, [loading]);

  const getProposalReferees = useCallback(
    async (proposalId) => {
      const loadingId = loading.addLoading("loading Reviewers");
      var proposalReferees = await service.getProposalRefereesByProposalId({
        proposalId,
      });
      proposalReferees = proposalReferees.filter(
        (pr) => pr.recommendedBy === recommendedBy.ApplicantSuggestedReviewer
      );
      setProposalReferees(proposalReferees);
      loading.removeLoading(loadingId);
    },
    [loading]
  );

  const fillTitlesOptions = useCallback(async () => {
    const loadingId = loading.addLoading("loading titles");
    var titlesOptions = await service.GetContactTitles();
    setTitlesOptions(titlesOptions.map((t) => ({ ...t, id: t.value })));
    loading.removeLoading(loadingId);
  }, [loading]);

  const getProposalId = useCallback(async () => {
    const loadingId = loading.addLoading("loading applicant");
    const applicant = await service.getApplicant();
    loading.removeLoading(loadingId);
    return applicant.proposalfullnumber;
  }, [loading]);

  useEffect(() => {
    const getData = async () => {
      const loadingId = loading.addLoading("Loading proposalid");
      const proposalId = await getProposalId();
      setproposalId(proposalId);
      getProposalReferees(proposalId);
      fillInstitutionsOptions();
      fillCountriesOptions();
      fillTitlesOptions();
      loading.removeLoading(loadingId);
    };
    getData();
  }, [
    fillCountriesOptions,
    fillInstitutionsOptions,
    fillTitlesOptions,
    getProposalId,
    getProposalReferees,
    loading,
  ]);

  const tableConfig = useMemo(
    () => ({
      idField: "id",
      disableEdit: !canEdit,
      columns: [
        {
          id: "titleCode",
          label: "Title",
          field: "titleCode",
          type: "options",
          options: titlesOptions,
        },
        {
          id: "firstName",
          label: "First Name",
          field: "firstName",
          capitalize: true,
        },
        {
          id: "lastName",
          label: "Last Name",
          field: "lastName",
          capitalize: true,
        },
        {
          id: "institutionName",
          label: "Institution",
          field: "institutionName",
          type: "options",
          options: institutionOptions,
          width: 3,
        },
        {
          id: "websiteurl",
          label: "WebSite",
          field: "websiteurl",
          width: 2,
        },
        {
          id: "primaryEmail",
          label: "Email",
          field: "primaryEmail",
          width: 3,
        },
        {
          id: "institutionCountryId",
          label: "Country",
          field: "institutionCountryId",
          type: "options",
          options: countriesOptions,
          width: 2,
        },
      ],
    }),
    [institutionOptions, countriesOptions, titlesOptions, canEdit]
  );

  return (
    <>
      <InfoDialog
        open={showInfo}
        onClose={() => setShowInfo(false)}
        content={infoContent}
      ></InfoDialog>
      <Grid container>
        <Typography variant="subtitle2">Suggested Reviewers</Typography>
        <IconButton onClick={() => setShowInfo(true)}>
          <InfoOutlinedIcon color="primary" />
        </IconButton>
      </Grid>
      <Paper className={classes.root} elevation={0}>
        <EditableTable
          tableConfig={tableConfig}
          tableData={proposalReferees}
          rowValidate={validateRow}
          rowCreated={addRow}
          rowUpdated={setRow}
          rowDeleted={deleteRow}
        />
      </Paper>
    </>
  );
}
